import React, { useEffect, useState } from 'react';
import { CodeBody, Subtitle } from '../styledComponents';
import SchemaStructure from './SchemaStructure';
import CodeHighlight from './CodeHighlight';
import { BODY_TYPES } from './constants';
import { getPropertyType } from '../../../utils/spec-utils';
import { formatExample } from '../../../utils/format-data';
import { AttributeSelection } from "../AttributeSelection";

import '../api-explorer.css';

export const RequestBodySection = ({ endpoint, schema, bodyParam, belongsTo }) => {
  const [requestBodyExample, setRequestBodyExample] = useState({});
  const [requestBodyStructure, setRequestBodyStructure] = useState([]);
  const [requestExamples, setRequestExamples] = useState();
  const [selectedExample, setSelectedExample] = useState();

  const handleSelectedExample = (attrKey, example) => {
    // only handle examples
    if (attrKey === 'exs') {
      setSelectedExample(example.label);
      setRequestBodyExample(requestExamples[example.label]);
    }
  };

  useEffect(() => {
    if (!!schema) {
      const isOas3Spec = !!schema?.openapi && schema.openapi.indexOf('3') > -1;

      if (isOas3Spec) {
        let reqBodyExample;
        const requestExampleParent = endpoint.schema?.requestBody?.content
          ? Object.keys(endpoint.schema?.requestBody?.content)[0]
          : [];

        const reqBodyStructure = endpoint.schema?.requestBody?.content[requestExampleParent]?.schema;

        reqBodyExample =
          endpoint.schema?.requestBody?.content[requestExampleParent]?.schema
            ?.items?.example ||
          endpoint.schema?.requestBody?.content[requestExampleParent]?.schema
            ?.example;

        // OAS3 examples, take parent example over schema
        const schemaRequestContent = endpoint?.schema?.requestBody?.content?.[requestExampleParent];
        const parentExample = schemaRequestContent?.example || schemaRequestContent?.examples;
        if (!!parentExample) {
          reqBodyExample = parentExample;
        }

        // Handle multiple request examples
        if (typeof reqBodyExample === 'object') {      
          const reqEntries = Object.entries(reqBodyExample);
          // Check that every entry has a "value" property
          const everyEntryHasValue = reqEntries.map(e => e[1]).every(e => Object.keys(e || {})[0] === 'value');
          if (everyEntryHasValue) {
            // Remove the "value" property from the request entries
            const availableRequestExamples = Object.fromEntries(reqEntries.map(e => [e[0], e[1].value]));
            setRequestExamples(availableRequestExamples);
            const firstExample = Object.keys(availableRequestExamples)[0];
            setSelectedExample(firstExample);
            reqBodyExample = availableRequestExamples[firstExample];
          }
        }

        reqBodyExample =
          !!reqBodyStructure && !reqBodyExample
            ? getPropertyType(reqBodyStructure)
            : reqBodyExample;
        setRequestBodyStructure(reqBodyStructure);
        setRequestBodyExample(reqBodyExample);
      } else {
        const reqBodyStructure = bodyParam?.schema;
        const reqBodyExample = bodyParam?.schema?.example;

        setRequestBodyStructure(reqBodyStructure);
        setRequestBodyExample(reqBodyExample);
      }
    }
  }, [schema, endpoint]);

  return (
    <>
      {requestBodyStructure && Object.keys(requestBodyStructure).length > 0 && (
        <>
          <Subtitle>Request Body Structure</Subtitle>
          <SchemaStructure
            structure={'Request'}
            schema={requestBodyStructure}
            type={BODY_TYPES.request}
            belongsTo={belongsTo}
          />
        </>
      )}
      {requestBodyExample && (
        <>
          <Subtitle>Request Body Example</Subtitle>
          {requestExamples && Object.keys(requestExamples).length > 0 && (
            <AttributeSelection
              dataTestId="request-examples-select"
              key="request-examples-drop-down"
              id="request-examples-drop-down"
              attributeKey="exs"
              items={Object.keys(requestExamples)}
              onItemSelection={handleSelectedExample}
              defaultOption={selectedExample}
            />
          )}
          <CodeBody data-cy={`apiexplorer-param-body`}>
            <CodeHighlight language={`${typeof requestBodyExample === 'object' ? 'json': 'markup'}`}>
              {formatExample(requestBodyExample)}
            </CodeHighlight>
          </CodeBody>
        </>
      )}
    </>
  );
};
